import { useReducer } from "react";


export function useUpdate(): () => void
{
    let [, update] = useReducer(state => state + 1, 0);
    return update;
}
